import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BrandService } from '@lc/core/lib/services/brand.service';

@Component({
  selector: 'lc-privacy-policy-page',
  templateUrl: './privacy-policy-page.component.html',
  styleUrls: ['./privacy-policy-page.component.scss'],
  imports: [MatIconModule],
})
export class PrivacyPolicyPageComponent {
  brandService = inject(BrandService);
}
